import React from 'react';
import { useAuth } from '../contexts/AuthContext';
import { useNavigate } from 'react-router-dom';
import './AdminDashboard.css';

const AdminDashboard: React.FC = () => {
  const { isAdmin } = useAuth();
  const navigate = useNavigate();

  if (!isAdmin) {
    navigate('/');
    return null;
  }

  return (
    <div className="admin-page">
      <div className="hero-section">
        <h1>Admin Dashboard</h1>
        <p>Manage players, teams, and rankings</p>
      </div>

      <div className="admin-container">
        <div className="admin-grid">
          <div className="admin-card">
            <div className="card-icon">👥</div>
            <h3>Manage Players</h3>
            <p>Add, edit, or remove player profiles</p>
            <button className="btn-action">Manage Players</button>
          </div>

          <div className="admin-card">
            <div className="card-icon">🏆</div>
            <h3>Manage Teams</h3>
            <p>Create and update team information</p>
            <button className="btn-action">Manage Teams</button>
          </div>

          <div className="admin-card">
            <div className="card-icon">📊</div>
            <h3>Update Rankings</h3>
            <p>Evaluate and rank player performance</p>
            <button className="btn-action">Update Rankings</button>
          </div>

          <div className="admin-card">
            <div className="card-icon">📈</div>
            <h3>View Analytics</h3>
            <p>Access performance metrics and reports</p>
            <button className="btn-action">View Analytics</button>
          </div>
        </div>

        <div className="quick-stats">
          <h2>Quick Stats</h2>
          <div className="stats-grid">
            <div className="stat-box">
              <div className="stat-value">--</div>
              <div className="stat-label">Total Players</div>
            </div>
            <div className="stat-box">
              <div className="stat-value">--</div>
              <div className="stat-label">Active Teams</div>
            </div>
            <div className="stat-box">
              <div className="stat-value">--</div>
              <div className="stat-label">Rankings Updated</div>
            </div>
            <div className="stat-box">
              <div className="stat-value">--</div>
              <div className="stat-label">Evaluations</div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AdminDashboard;
